import { LoggerService } from '../services/logger.service';

export class Logger {
  private static loggerService: LoggerService;

  static init(logger: LoggerService): void {
    this.loggerService = logger;
  }

  static log(message?: any, ...optionalParams: any[]): void {
    this.ensureInitialized();
    this.loggerService.log(message, ...optionalParams);
  }

  static warn(message?: any, ...optionalParams: any[]): void {
    this.ensureInitialized();
    this.loggerService.warn(message, ...optionalParams);
  }

  static error(message?: any, ...optionalParams: any[]): void {
    this.ensureInitialized();
    this.loggerService.error(message, ...optionalParams);
  }

  static debug(message?: any, ...optionalParams: any[]): void {
    this.ensureInitialized();
    this.loggerService.debug(message, ...optionalParams);
  }

  private static ensureInitialized(): void {
    if (!this.loggerService) {
      throw new Error('Logger not initialized! Call Logger.init() in your AppModule.');
    }
  }
}